import { render, staticRenderFns } from "./QuestSlider.vue?vue&type=template&id=6bc2ce60&scoped=true&"
import script from "./QuestSlider.vue?vue&type=script&lang=js&"
export * from "./QuestSlider.vue?vue&type=script&lang=js&"
import style0 from "./QuestSlider.vue?vue&type=style&index=0&id=6bc2ce60&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc2ce60",
  null
  
)

export default component.exports